import { Link } from "react-router-dom";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Header";
import { SOCIAL, STUDIO, WHATSAPP } from "@/lib/api";
import { useSite } from "./SiteLayout";

const LEGAL = [["/privacy-policy", "Privacy Policy"], ["/cookie-policy", "Cookie Policy"], ["/termini-e-condizioni", "Termini e condizioni"]];

export const Footer = () => {
  const { menu } = useSite();
  const links = menu.filter((n) => n.to !== "/").map((n) => [n.to, n.label, n.external]);
  return (
  <footer className="sec-dark" data-testid="site-footer">
    <div className="container-x pt-24 sm:pt-32 pb-10">
      <div className="grid grid-cols-12 gap-x-6 gap-y-14 pb-20 border-b border-line">
        <div className="col-span-12 lg:col-span-6">
          <p className="eyebrow mb-8 flex items-center gap-4"><span className="rule-gold" />Parliamone</p>
          <p className="font-serif font-light text-[32px] sm:text-[46px] leading-[1.1] tracking-[-0.03em] max-w-xl">
            Ogni storia inizia <em className="italic text-oliva">con una conversazione.</em>
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn-ink" data-testid="footer-whatsapp">WhatsApp <ArrowUpRight size={14} /></a>
            <Link to="/contatti" className="btn-line" data-testid="footer-contatti-cta">Compila il modulo</Link>
          </div>
        </div>

        <nav className="col-span-12 sm:col-span-4 lg:col-span-3" aria-label="Link del sito">
          <p className="eyebrow mb-7">Naviga</p>
          <ul className="space-y-3.5 text-[14.5px] font-light">
            {links.map(([to, l, ext]) => <li key={to + l}>{ext
              ? <a href={to} target="_blank" rel="noreferrer" className="link-u">{l}</a>
              : <Link to={to} className="link-u" data-testid={`footer-link-${to.slice(1)}`}>{l}</Link>}</li>)}
            <li><Link to="/area-clienti" className="link-u text-oliva" data-testid="footer-link-area-clienti">Area clienti</Link></li>
          </ul>
        </nav>

        <address className="col-span-12 sm:col-span-8 lg:col-span-3 not-italic text-[14.5px] font-light text-stoneish space-y-2 break-words" data-testid="footer-studio-data">
          <p className="eyebrow mb-7">Studio</p>
          <p className="text-ink">{STUDIO.name}</p>
          <p>{STUDIO.street}</p>
          <p>{STUDIO.city}</p>
          <p className="pt-3"><a href={`mailto:${STUDIO.email}`} className="link-u">{STUDIO.email}</a></p>
          <p><a href={`tel:${STUDIO.phone.replace(/\s/g, "")}`} className="link-u">{STUDIO.phone}</a></p>
          <div className="flex gap-6 pt-6 text-oliva">
            <a href={SOCIAL.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="transition-opacity duration-500 hover:opacity-60"><Instagram size={17} strokeWidth={1.4} /></a>
            <a href={SOCIAL.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="transition-opacity duration-500 hover:opacity-60"><Facebook size={17} strokeWidth={1.4} /></a>
          </div>
        </address>
      </div>

      <div className="pt-10 flex flex-col lg:flex-row lg:items-end justify-between gap-10">
        <div>
          <Wordmark light />
          <p className="mt-5 text-[11.5px] uppercase tracking-[0.22em] text-mute">Fotografi dal 1982 · Sassa Scalo, L'Aquila</p>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center gap-x-7 gap-y-3 text-[11.5px] uppercase tracking-[0.14em] text-mute">
          {LEGAL.map(([to, l]) => <Link key={to} to={to} className="transition-colors duration-500 hover:text-ink">{l}</Link>)}
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors duration-500 hover:text-ink">Gestionale</Link>
        </div>
      </div>
      <p className="mt-10 text-[11px] uppercase tracking-[0.14em] text-mute">© {new Date().getFullYear()} {STUDIO.brand} · P.IVA {STUDIO.vat}</p>
    </div>
  </footer>
  );
};
